export default __webpack_public_path__ + "static/contributions-4643caaad2df3ce6d4af244c3bbabf48.png";